import { useOptionsApi } from '@innowise-group/core';
import { Controller, useFormContext } from 'react-hook-form';
import * as Styled from './candidate-working-info-form.styles';
import { Input, Select } from '@innowise-group/mui-kit';
import { useTranslation } from 'react-i18next';
import { EmployeeField } from '@shared-mui-components';

const CandidateWorkingInfoForm = () => {
  const { t } = useTranslation();

  const { control, watch } = useFormContext();
  const { professionOptions, gradeOptions, unitOptions, divisionOptions, departmentOptions } = useOptionsApi();

  const isCandidateAlreadyLinked = !!watch('hrmId');

  return (
    <Styled.Container>
      <Styled.Row>
        <Controller
          name="hrmEmail"
          control={control}
          render={({ field: { onChange, value }, formState: { errors } }) => {
            return (
              <Input
                value={value}
                onChange={onChange}
                label={t('pages.candidates.candidateCreation.corporateEmail')}
                placeholder={t('pages.candidates.candidateCreation.enterTheEmail')}
                error={!!errors['hrmEmail']?.message}
                helperText={errors['hrmEmail']?.message.toString()}
                disabled={isCandidateAlreadyLinked}
              />
            );
          }}
        />
      </Styled.Row>

      <Styled.Row>
        <Controller
          name="positionId"
          control={control}
          render={({ field: { onChange, value } }) => {
            return (
              <Select
                value={value}
                onChange={onChange}
                options={professionOptions}
                disableSortByAlphabet={false}
                renderInput={(params) => {
                  return (
                    <Input
                      {...params}
                      label={t('pages.candidates.candidateCreation.position')}
                      placeholder={t('common.placeholders.selectValue')}
                    />
                  );
                }}
              />
            );
          }}
        />

        <Controller
          name="grade"
          control={control}
          render={({ field: { onChange, value } }) => {
            return (
              <Select
                value={value}
                onChange={onChange}
                options={gradeOptions}
                renderInput={(params) => {
                  return (
                    <Input
                      {...params}
                      label={t('pages.candidates.candidateCreation.grade')}
                      placeholder={t('common.placeholders.selectValue')}
                    />
                  );
                }}
              />
            );
          }}
        />
      </Styled.Row>

      <Styled.Row>
        <Controller
          name="unitId"
          control={control}
          render={({ field: { onChange, value } }) => (
            <Select
              value={value}
              onChange={onChange}
              options={unitOptions}
              renderInput={(params) => {
                return (
                  <Input
                    {...params}
                    label={t('pages.candidates.candidateCreation.unit')}
                    placeholder={t('common.placeholders.selectValue')}
                  />
                );
              }}
            />
          )}
        />

        <Controller
          name="divisionId"
          control={control}
          render={({ field: { onChange, value } }) => (
            <Select
              value={value}
              onChange={onChange}
              options={divisionOptions}
              renderInput={(params) => {
                return (
                  <Input
                    {...params}
                    label={t('pages.candidates.candidateCreation.division')}
                    placeholder={t('common.placeholders.selectValue')}
                  />
                );
              }}
            />
          )}
        />
      </Styled.Row>

      <Styled.Row>
        <Controller
          name="departmentId"
          control={control}
          render={({ field: { onChange, value } }) => (
            <Select
              value={value}
              onChange={onChange}
              options={departmentOptions}
              renderInput={(params) => {
                return (
                  <Input
                    {...params}
                    label={t('pages.candidates.candidateCreation.department')}
                    placeholder={t('common.placeholders.selectValue')}
                  />
                );
              }}
            />
          )}
        />
      </Styled.Row>

      <Styled.Row>
        <EmployeeField
          field="head"
          label="pages.candidates.candidateCreation.head"
          placeholder="common.placeholders.selectHead"
        />
        <EmployeeField
          field="resourceManager"
          label="pages.candidates.candidateCreation.resourceManager"
          placeholder="common.placeholders.selectManager"
        />
      </Styled.Row>

      <Styled.Row>
        <Controller
          name="comment"
          control={control}
          render={({ field: { onChange, value }, formState: { errors } }) => (
            <Input
              label={`${t('pages.candidates.candidateCreation.comment')}`}
              error={!!errors['comment']?.message}
              helperText={errors['comment']?.message.toString()}
              value={value}
              multiline
              minRows={2}
              maxRows={12}
              onChange={onChange}
              placeholder={t('common.placeholders.fillComment')}
            />
          )}
        />
      </Styled.Row>
    </Styled.Container>
  );
};

export default CandidateWorkingInfoForm;
